var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item-subtitle',[(_vm.origin != 'customer')?_c('v-icon',{attrs:{"size":"16","color":_vm.status >= 4 ? 'blue' : 'grey lighten-1'}},[_vm._v(" mdi-check-all ")]):_vm._e(),_vm._v(" "+_vm._s(_vm.type ? (_vm.type === 'text' ? _vm.message : _vm.media_types[_vm.type]) : _vm.message || '')+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }